import { TabNav, TabNavItem } from '@/platform/ui';
import { Link, usePage } from '@inertiajs/react';

const Navigation = () => {
    const { auth } = usePage().props;
    const { component } = usePage();

    const base = `/customers/${auth?.customer?.id}/services/missing-data`;

    return (
        <TabNav label='Pagina' className='mb-4'>
            <TabNavItem
                as={Link}
                href={`${base}/edit`}
                active={component === 'MissingData/EditView'}
            >
                Bijwerken
            </TabNavItem>
            <TabNavItem
                as={Link}
                href={`${base}/overview`}
                active={component === 'MissingData/OverviewView'}
            >
                Overzicht
            </TabNavItem>
        </TabNav>
    );
};

export default Navigation;
